import { Sex } from '../../model/client/profile/sex';

export const SEX_TRANSLATIONS: Record<Sex, string> = {
  [Sex.Male]: 'мужчина',
  [Sex.Female]: 'женщина',
};
